<template>
	<v-app id="zarinpalCallback-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<a href="/" class="d-flex align-center">
				<img src="/logo-wide.png" style="max-width: 80px; max-height: 32px" class="hidden-sm-and-down" />

				<!-- نسخه کوچکتر برای موبایل -->
				<img src="/logo-wide.png" style="max-width: 60px; max-height: 28px" class="hidden-md-and-up" />
			</a>
			<div class="">
				<span class="warning--text text-truncate">{{ longTitle }}</span>
			</div>
		</v-app-bar>
		<v-container>
			<v-row justify="center" class="mb-12">
				<v-col cols="12" md="6" v-if="loading || !isSuccess">
					<v-card class="mx-auto">
						<div class="d-flex flex-column justify-center align-center" style="height:200px;"
							:style="{ 'background-color': bg }">
							<v-icon size="large" :color="color" style="font-size: 100px;">
								{{ icon }}
							</v-icon>
						</div>
						<div class="form-group text-center pa-5">
							<div v-if="message" v-html="message">

							</div>
						</div>
					</v-card>
				</v-col>
			</v-row>
			<v-row class="justify-center" justify="center" v-if="!loading && isSuccess">
				<v-col cols="12" md="10">
					<v-card color="white" class="">
						<div class="form-group text-right pa-5">
							<div class="text-center pa-5">
								<v-btn fab color="secondary" elevation="0" x-large>
									<v-icon color="white">mdi-file-sign</v-icon>
								</v-btn>
							</div>
							<p class="text-body secondary--text text-center" style="text-align: justify;">کاربر گرامی در
								این صفحه می توانید متن قرارداد مورد ضمانت را مشاهده نمایید و اقدام به امضا دیجیتال
								فرمایید.</p>
							<div class="my-2">
								<ThirdPersonContractDetail v-if="data.thirdPersonAssuranceAuthorizationItem"
									:thirdPersonAssuranceAuthorizationItem="data.thirdPersonAssuranceAuthorizationItem"
									:mobile="data.mobile" />
							</div>
						</div>
					</v-card>

				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
	import { get, call } from 'vuex-pathify'
	import api from '@/util/app-api'
	import ThemeManager from '@/util/theme-manager.js'
	import toast from '@/util/toast'

	const INVALIDMSG = 'اطلاعات معتبر نمی باشد'
	export default {
		name: 'PreThirdPersonDigitalSignContract',
		components: {
			ThirdPersonContractDetail: () => import('@/components/loanAuthorizations/ThirdPersonContractDetail'),
		},
		data() {
			return {
				userLoanPayment: null,
				errorMessages: '',
				data: { customerCode: 0, mobile: '', thirdPersonAssuranceAuthorizationItem: null },
				submitLoading: false,
				loading: false,
				isSuccess: null,
				message: ''
			}
		},
		computed: {
			...get('siteConfig', [
				'longTitle'
			]),
			...get('appSettings', [
				'landingSettings'
			]),
			bg() {
				if (this.loading)
					return '#dadada'
				if (this.isSuccess)
					return 'rgb(182 255 193)'
				return 'rgb(255 227 227)'
			},
			color() {
				if (this.loading)
					return '#aaa'
				if (this.isSuccess)
					return '#0dd400'
				return '#ff5722'
			},
			icon() {
				if (this.loading)
					return 'mdi-timer-sand'
				if (this.isSuccess)
					return 'mdi-credit-card-check'
				return 'mdi-alert-circle-outline'
			},
			title() {
				if (this.loading)
					return 'در حال بررسی'
				if (this.isSuccess)
					return 'پرداخت موفق'
				return 'پرداخت ناموفق'
			}
		},
		created() {

		},
		mounted() {
			if (!this.$route.params.ccode || !this.$route.params.acode) {
				this.message = INVALIDMSG
				return
			}
			this.verify()
			this.loadAppSettings({ force: true, customerCode: this.$route.params.ccode })
		},
		methods: {
			loadAppSettings: call('appSettings/fetchLandingSettings'),
			verify() {
				this.message = 'در حال دریافت اطلاعات، لطفا تا پایان عملیات منتظر بمانید...'
				this.loading = true
				let data = {
					cCode: this.$route.params.ccode,
					aCode: this.$route.params.acode
				}
				api.post('ThirdPersonAssuranceAuthorizationItem/PreDigitalSignContract', data, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.isSuccess = true
						this.data.member = response.member
						this.data.mobile = response.mobile
						this.data.thirdPersonAssuranceAuthorizationItem = response.authorizationItem
						this.data.thirdPersonAssuranceAuthorizationItem.customerCode = data.cCode
					})
					.catch(error => {
						this.isSuccess = false
						this.message = error.message || error.toString()
					})
					.finally(() => {
						this.loading = false
					})
			},
			returnToPanel() {
				this.$router.push('/member/dashboard')
			}
		},
	}
</script>

<style scoped></style>
